import useBranch from "../atoms/useBranch";
import { useSetModal } from "../atoms/useModal";
import { generateGoogleUrl } from "../utils/helpers";
import { OrderV2 } from "../v2/queries/interfacesV2";

const useOpenQrModal = () => {
  const [branch] = useBranch();
  const setModal = useSetModal();
  return (orders: OrderV2[]) => {
    return setModal("qr", { url: generateGoogleUrl(branch, orders) });
  };
};

export default useOpenQrModal;
